module.exports = __webpack_public_path__ + "static/media/internal_link.7003a85b.svg";